import { Component } from 'react';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        console.error('[ErrorBoundary]', error, info.componentStack);
    }

    render() {
        if (this.state.hasError) {
            return (
                <main className="content" style={{ textAlign: 'center', padding: '4rem 1rem' }}>
                    <h2>Something went wrong</h2>
                    <p style={{ color: 'var(--text-muted)', marginBottom: '1.5rem' }}>
                        {this.state.error?.message || 'An unexpected error occurred.'}
                    </p>
                    <button onClick={() => window.location.reload()}>Reload page</button>
                </main>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
